<template>
  <div class="row column">
    <br />
    <h5 class="text-center">
      <unicon name="book-open" :fill="secCol" style="margin-right: 8px;">
      </unicon>
      <span class="text-barlow-condensed">Libros</span>
    </h5>

    <ul
      class="vertical menu kal-aside-menu__list"
      data-responsive-menu="drilldown medium-accordion"
    >
      <li v-for="(item, index) in menu.books.children" :key="index">
        <router-link
          :to="item.link"
          v-slot="{ href, route, navigate, isExactActive }"
        >
          <a :href="href" @click="navigate">
            <unicon :name="item.icon" :fill="secCol"></unicon>
            <span
              :class="[
                isExactActive || 'subtitle',
                isExactActive && 'text-logo',
              ]"
              >{{ item.text }}</span
            >
          </a>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BooksMenu",
  data() {
    let { secCol } = this.$store.getters;

    return {
      secCol,
    };
  },
  computed: {
    ...mapState(["menu"]),
  },
};
</script>
